export default "__VITE_ASSET__hvxm6ZFc__"